import { MerchantDto } from 'src/generated-api-client';
import { merchantsApi } from 'src/services/apiServices';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { Pager } from 'src/utils/mobx/Pager';
import { Sorter } from 'src/utils/mobx/Sorter';
import { RequestHelper } from 'src/utils/RequestHelper';

export class MerchantsStoreClass extends BasicStore<
    MerchantDto,
    Record<string, any>,
    MerchantDto,
    MerchantDto,
    MerchantDto
> {
    api: BasicStoreApi<MerchantDto, MerchantDto, MerchantDto, MerchantDto> = {
        loadList: async (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            const response = await RequestHelper.unwrapFromAxiosPromise(
                merchantsApi.findAllMerchantsForBackoffice(
                    {
                        page: this.pager?.page,
                        size: this.pager?.size,
                        sort: this.sorter?.sort,
                    },
                    options,
                ),
            );
            this.pager?.setTotal(response.totalElements ?? 0);

            return response.content ?? [];
        },
        loadItem: async (id, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            const response = await RequestHelper.unwrapFromAxiosPromise(
                merchantsApi.getMerchantForBackoffice({ id }, options),
            );

            return response ?? null;
        },
    };

    pager = new Pager();
    sorter = new Sorter<MerchantDto>();
}

// Shared singleton instance of Merchants store
export const MerchantsStore = new MerchantsStoreClass();
